import { render, staticRenderFns } from "./InventoriesTasksList.vue?vue&type=template&id=ad2d10f8&scoped=true&"
import script from "./InventoriesTasksList.vue?vue&type=script&lang=ts&"
export * from "./InventoriesTasksList.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesTasksList.vue?vue&type=style&index=0&id=ad2d10f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2d10f8",
  null
  
)

export default component.exports